// English mirror of the MEDISISTEM institutional content.
// Brand/line/product names (LUMAVEN, SCHIEBLER, STAR COTTON, GOLDPUNKT KARAT, DOKTUS, RAL)
// and company data are NOT translated. Only descriptive copy is translated.
export { IMG } from "@/lib/site";
import { IMG } from "@/lib/site";

export const CONTACT = {
  company: "Medisistem sas",
  legalName: "Medisistem snc di Mario de Peppo & C.",
  piva: "06546510634",
  pec: "medisistem@pec.it",
  address: "Via Giuseppe Bonito 19, Naples (Italy)",
  tel1: "081.7433033",
  tel2: "081.5920490",
  mobile: "339.1424138",
  email: "info@medisistem.it",
  web: "www.medisistem.it",
  payoff: "Reliability you can wear.",
  since: "Since 1986",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/chi-siamo" },
  { label: "Solutions", to: "/soluzioni" },
  {
    label: "Products",
    to: "/prodotti",
    children: [
      { label: "Therapeutic & curative stockings – SCHIEBLER", to: "/prodotti/schiebler" },
      { label: "Preventive & anti-thrombosis stockings – LUMAVEN", to: "/prodotti/lumaven" },
      { label: "Bandages", to: "/prodotti/bendaggi" },
      { label: "Pressotherapy", to: "/prodotti/pressoterapia" },
    ],
  },
  { label: "The Method", to: "/il-metodo" },
  { label: "Services", to: "/servizi" },
  { label: "Channels", to: "/canali" },
  { label: "Contact", to: "/contatti" },
];

export const STATS = [
  { value: "40+", label: "Years of experience" },
  { value: "100%", label: "Specialised" },
  { value: "Ongoing", label: "Support" },
];

export const STOCKINGS = [
  {
    id: "terapeutiche",
    title: "Therapeutic compression",
    subtitle: "Therapeutic & curative stockings",
    theme: "navy",
    featured: true,
    cat: "terapeutiche",
    to: "/prodotti?cat=terapeutiche",
    desc: "Certified medical compression for the treatment of chronic venous insufficiency and lymphoedema.",
  },
  {
    id: "preventive",
    title: "Preventive compression",
    subtitle: "Preventive stockings",
    theme: "green",
    cat: "preventive",
    to: "/prodotti?cat=preventive",
    desc: "Light, discreet support for the legs of those who stand or sit for long hours, during pregnancy and while travelling.",
  },
  {
    id: "antitrombo",
    title: "Anti-thrombosis",
    subtitle: "Anti-thrombosis stockings",
    theme: "green-alt",
    cat: "antitrombo",
    to: "/prodotti?cat=antitrombo",
    desc: "Anti-thromboembolic prophylaxis for bedridden patients and the post-operative pathway, both in-store and at home.",
  },
];

export const COMPLEMENTS = [
  { id: "bendaggi", label: "Bandages", to: "/prodotti?cat=bendaggi", desc: "Bandages for compression therapy and support: adhesive, cohesive, non-adhesive and other types." },
  { id: "pressoterapia", label: "Pressotherapy", to: "/prodotti?cat=pressoterapia", desc: "Sequential lymphatic drainage systems for the limbs." },
];

export const PRODUCT_FILTERS = [
  { id: "tutti", label: "All products" },
  { id: "terapeutiche", label: "Therapeutic & curative stockings" },
  { id: "preventive", label: "Preventive stockings" },
  { id: "antitrombo", label: "Anti-thrombosis stockings" },
  { id: "bendaggi", label: "Bandages" },
  { id: "pressoterapia", label: "Pressotherapy" },
];

export const CATALOG = [
  { id: "sch-start", cat: "terapeutiche", catLabel: "Therapeutic & curative stockings", name: "STAR COTTON", brand: "SCHIEBLER", img: IMG.schiebler, short: "Curative cotton stocking: maximum comfort for prolonged use and sensitive skin.", to: "/prodotti/schiebler" },
  { id: "sch-gold", cat: "terapeutiche", catLabel: "Therapeutic & curative stockings", name: "GOLDPUNKT KARAT", brand: "SCHIEBLER", img: IMG.goldpunkt, short: "The SCHIEBLER reference line: precision, durability and anatomical fit.", to: "/prodotti/schiebler" },
  { id: "sch-doktus", cat: "terapeutiche", catLabel: "Therapeutic & curative stockings", name: "DOKTUS", brand: "SCHIEBLER", img: IMG.doktus, short: "Precise graduated compression for the most complex clinical cases and lymphoedema.", to: "/prodotti/schiebler" },
  { id: "lum-prev", cat: "preventive", catLabel: "Preventive stockings", name: "Preventive Stockings", brand: "LUMAVEN", img: IMG.lumaven, short: "Light, discreet everyday support, for pregnancy and travel.", to: "/prodotti/lumaven" },
  { id: "lum-anti", cat: "antitrombo", catLabel: "Anti-thrombosis stockings", name: "Anti-thrombosis Stockings", brand: "LUMAVEN", img: IMG.antitrombo, short: "Anti-thromboembolic prophylaxis for bedridden patients and the post-operative pathway.", to: "/prodotti/lumaven" },
  { id: "bend-adesivi", cat: "bendaggi", catLabel: "Bandages", name: "Adhesive bandages", brand: "Wero Swiss", img: null, short: "Muscle, tendon and joint support with porous adhesive fixing.", to: "/prodotti/bendaggi#scheda-adesivi" },
  { id: "bend-coesivi", cat: "bendaggi", catLabel: "Bandages", name: "Cohesive bandages", brand: "Wero Swiss", img: null, short: "Non-slip, for the decongestion phase of compression therapy.", to: "/prodotti/bendaggi#scheda-coesivi" },
  { id: "bend-nonadesivi", cat: "bendaggi", catLabel: "Bandages", name: "Non-adhesive bandages", brand: "Wero Swiss", img: null, short: "Short, medium and strong stretch for compression, orthopaedics and sport.", to: "/prodotti/bendaggi#scheda-non-adesivi" },
  { id: "presso-advance", cat: "pressoterapia", catLabel: "Pressotherapy", name: "ADVANCE Pressotherapy", brand: "LEM", img: IMG.pressotherapy, short: "Electronic pressotherapy with 4 outlets and A/B sequential programmes.", to: "/prodotti/pressoterapia" },
];

export const BRANDS = [
  {
    id: "lumaven",
    name: "LUMAVEN",
    badge: "Medisistem Proprietary Brand",
    theme: "green",
    to: "/prodotti/lumaven",
    desc: "The Medisistem proprietary line dedicated to prevention and anti-thrombosis prophylaxis.",
    pills: ["Preventive", "Anti-thrombosis"],
  },
  {
    id: "schiebler",
    name: "SCHIEBLER",
    badge: "Exclusive Distributor for Italy",
    ral: true,
    theme: "navy",
    to: "/prodotti/schiebler",
    desc: "German excellence in therapeutic hosiery. Medisistem is the exclusive distributor for Italy.",
    pills: ["STAR COTTON", "GOLDPUNKT KARAT", "DOKTUS"],
  },
];

export const BRANDS_SECONDARY = [
  { id: "bendaggi", name: "Bandages", to: "/prodotti/bendaggi", desc: "Bandages for compression therapy: adhesive, cohesive, non-adhesive, zinc oxide and alginate." },
  { id: "pressoterapia", name: "Pressotherapy", to: "/prodotti/pressoterapia", desc: "Sequential pressotherapy systems for lymphatic drainage of the limbs." },
];

export const METHOD_STEPS = [
  { n: "01", title: "Consultation", desc: "We listen to your clinical history and the doctor's indications to understand the real need." },
  { n: "02", title: "Assessment", desc: "We analyse the venous and lymphatic condition to identify the correct compression class." },
  { n: "03", title: "Measurement", desc: "Professional measurement of circumferences and lengths, point by point." },
  { n: "04", title: "Selection", desc: "Together we choose the right product from the LUMAVEN and SCHIEBLER lines." },
  { n: "05", title: "Fitting", desc: "You try the stocking in-store: we check fit, comfort and correct compression." },
  { n: "06", title: "Support", desc: "We follow you over time with check-ups, replacements and ongoing support." },
];

export const METHOD_FLOW = [
  { title: "Specialist's prescription", desc: "The doctor indicates the appropriate compression class." },
  { title: "Professional measurement", desc: "We measure circumferences and lengths with precision." },
  { title: "Choosing the correct size", desc: "We identify the exact size, not just the class." },
  { title: "Stocking fitting", desc: "We verify real fit and comfort." },
  { title: "Comfort and effectiveness", desc: "A tailored device improves results." },
];

export const TESTIMONIALS = [
  { name: "Maria R.", role: "Naples", rating: 5, text: "After years of buying stockings at random, the measurement at Medisistem changed everything: comfortable and finally effective." },
  { name: "Dr. Antonio S.", role: "Phlebologist", rating: 5, text: "I refer my patients with peace of mind: the measurement is accurate and the fitting avoids any sizing error." },
  { name: "Giuseppe L.", role: "Naples", rating: 5, text: "Impeccable home service. Competent and kind staff who followed me step by step." },
  { name: "Carla M.", role: "Portici", rating: 5, text: "Finally someone who really explains and measures. The difference shows every day I wear the stockings." },
];

export const WHY = [
  { title: "Since 1986", desc: "Over forty years dedicated exclusively to elasto-compressive therapy." },
  { title: "100% Specialised", desc: "One single field, no distractions: only medical compression." },
  { title: "Proprietary brand", desc: "LUMAVEN is born and grows with us, total control over quality." },
  { title: "Exclusive distributor", desc: "SCHIEBLER for Italy: certified German excellence." },
  { title: "Professional measurement", desc: "The right size makes the difference in therapeutic effectiveness." },
  { title: "In-store or at home", desc: "We reach you wherever you are, with the same care and precision." },
  { title: "Stocking fitting", desc: "No blind purchase: you always try it first." },
  { title: "Ongoing support", desc: "A stable point of reference, over the years." },
];

export const SERVICES = [
  { title: "Specialist consultation", desc: "A dedicated discussion to guide you towards the correct therapeutic choice, in line with the medical prescription." },
  { title: "Professional measurement", desc: "Precise measurement of circumferences and lengths for the perfect made-to-measure stocking." },
  { title: "Stocking fitting", desc: "Together we verify fit and comfort before any final choice." },
  { title: "In-store service", desc: "A dedicated space in the heart of Naples, welcoming and private." },
  { title: "Home service", desc: "For those who cannot travel, we bring expertise and tools to your home." },
  { title: "Support", desc: "Ongoing support over time: check-ups, replacements and usage advice." },
];

export const VALUES = [
  { title: "Expertise", desc: "Knowledge built over more than forty years of daily practice." },
  { title: "Precision", desc: "Every measurement counts: we work with methodical rigour." },
  { title: "Trust", desc: "Lasting relationships with patients and healthcare professionals." },
  { title: "Care", desc: "The person at the centre, before the product." },
  { title: "Quality", desc: "Only certified products and premium materials." },
  { title: "Continuity", desc: "A stable reference, present over the years." },
];

export const TIMELINE = [
  { year: "1986", text: "The founding partner begins working in the sector as a representative of a company specialised in the distribution of compression stockings." },
  { year: "1992", text: "Medisistem is founded: the experience gained since 1986 becomes a company dedicated to elasto-compressive therapy." },
  { year: "1998", text: "Consolidation of the specialised centre in Naples and the first made-to-measure measurement pathways." },
  { year: "2005", text: "Expansion of clinical expertise and the network of collaborating professionals." },
  { year: "2012", text: "LUMAVEN is born, the Medisistem proprietary brand for prevention and anti-thrombosis." },
  { year: "2016", text: "Medisistem becomes the exclusive distributor for Italy of the SCHIEBLER brand." },
  { year: "2020", text: "Strengthening of the home service and ongoing support." },
  { year: "2026", text: "Over forty years of experience in the sector: a recognised centre of reference." },
];

export const CHANNELS = [
  { id: "farmacie", title: "Pharmacies", desc: "A reliable partner to offer customers certified compression stockings and devices, with technical support and dedicated training on correct measurement." },
  { id: "sanitarie", title: "Medical & Orthopaedic Stores", desc: "Supply of LUMAVEN and SCHIEBLER products and professional support for taking measurements and choosing the compression class." },
  { id: "operatori", title: "Healthcare Workers", desc: "Nurses and operators who manage the patient daily: tools, devices and support for applying and monitoring the therapy." },
  { id: "medici", title: "Specialist Doctors", desc: "Phlebologists, angiologists and vascular surgeons: a reference for prescribing elasto-compressive therapy and taking charge of patients." },
  { id: "strutture", title: "Healthcare Facilities", desc: "Hospitals, clinics and care homes that need anti-thrombosis stockings, bandages and pressotherapy systems for prophylaxis and inpatient care." },
  { id: "pazienti", title: "Patients", desc: "People looking for a made-to-measure compression solution, with professional measurement, stocking fitting and support in-store or at home." },
];

export const COMPANY_INTRO = [
  "Medisistem's experience in the sector began in 1986 and became a company in 1992: since then we have specialised in elasto-compressive therapy and in the distribution of medical devices dedicated to the prevention and treatment of venous and lymphatic conditions.",
  "For over forty years we have supported specialist doctors, pharmacies, medical and orthopaedic stores, healthcare facilities and patients, offering selected products, qualified advice and high-value services.",
  "We believe that the quality of a medical device is essential, but that its real benefit also depends on the expertise with which it is recommended, measured and applied.",
  "That is why our goal is not simply to distribute products, but to guide every customer in choosing the most suitable solution, ensuring professionalism, safety and therapeutic effectiveness.",
];

export const HOME_ABOUT = "For over forty years we have supported healthcare professionals and patients in choosing the best solutions for elasto-compressive therapy, offering quality products, specialist advice and a professional measurement service that ensures comfort, therapeutic effectiveness and safety.";

export const SCHIEBLER_INTRO = {
  title: "Exclusive distributor for Italy",
  paragraphs: [
    "Medisistem is the exclusive distributor for the Italian market of SCHIEBLER products, a historic German brand internationally recognised for its excellence in elasto-compressive therapy.",
    "Thanks to this partnership, Medisistem guarantees its customers direct access to SCHIEBLER products, ensuring technical expertise, specialised advice and qualified support in choosing the most suitable solution.",
  ],
};

export const MISSION = "We offer professional solutions for elasto-compressive therapy, selecting the best medical devices and supporting healthcare professionals and patients with qualified advice, personalised services and care oriented towards the person's wellbeing.";

export const VISION = "To become the national point of reference in elasto-compressive therapy, standing out for expertise, product quality, innovation and services that concretely improve the patient's experience and the work of healthcare professionals.";

export const METHOD_BENEFITS = [
  "Correct fit",
  "Greater therapy effectiveness",
  "More comfort in daily life",
  "Fewer returns and replacements",
  "Greater patient satisfaction",
  "Confidence in the treatment and the product",
];

export const PRODUCT_GROUPS = [
  {
    id: "lumaven",
    anchor: "prod-lumaven",
    to: "/prodotti/lumaven",
    name: "LUMAVEN",
    logo: "/brands/lumaven.png",
    badge: "Medisistem Proprietary Brand",
    theme: "green",
    intro: "The Medisistem proprietary line for prevention and anti-thrombosis prophylaxis.",
    items: [
      {
        id: "lum-prev",
        name: "Preventive Stockings",
        img: IMG.lumaven,
        short: "Light, discreet support for everyday use.",
        desc: "Designed for those who stand or sit for long hours, for pregnancy and for travel. Constant support for circulation, without giving up comfort and elegance.",
        specs: ["Light graduated compression", "Prevention of venous stasis", "Breathable, comfortable fabric", "Discreet fit"],
      },
      {
        id: "lum-anti",
        name: "Anti-thrombosis Stockings",
        img: IMG.antitrombo,
        short: "Anti-thromboembolic prophylaxis in hospital and at home.",
        desc: "Devices for the prevention of deep vein thrombosis in bedridden patients and the post-operative pathway, with an inspection opening at the foot.",
        specs: ["DVT prevention", "Foot inspection opening", "Decreasing compression", "Hospital and home use"],
      },
    ],
  },
  {
    id: "schiebler",
    anchor: "prod-schiebler",
    to: "/prodotti/schiebler",
    name: "SCHIEBLER",
    logo: "/brands/schiebler.png",
    badge: "Exclusive Distributor for Italy",
    ral: true,
    theme: "navy",
    intro: "German excellence in therapeutic hosiery, with the RAL quality mark.",
    items: [
      {
        id: "sch-start",
        name: "STAR COTTON",
        img: IMG.schiebler,
        badge: "Main Product",
        short: "The cotton therapeutic stocking, comfort for sensitive skin.",
        desc: "Maximum comfort in contact with the skin thanks to natural cotton fibre: ideal for prolonged use and for those with sensitive skin.",
        specs: ["Natural cotton fibre", "High breathability", "Certified compression classes", "RAL mark"],
      },
      {
        id: "sch-gold",
        name: "GOLDPUNKT KARAT",
        img: IMG.goldpunkt,
        badge: "Main Product",
        short: "The SCHIEBLER reference line, precision and durability.",
        desc: "German precision and long-lasting durability for daily therapy, with anatomical fit and refined aesthetics.",
        specs: ["Anatomical fit", "High therapeutic performance", "Refined aesthetics", "RAL mark"],
      },
      {
        id: "sch-doktus",
        name: "DOKTUS",
        img: IMG.doktus,
        badge: "Main Product",
        short: "Therapeutic precision for demanding clinical cases.",
        desc: "Reliable graduated compression for the most complex clinical situations, with specific support for lymphoedema.",
        specs: ["Precise graduated compression", "Lymphoedema support", "Durable materials", "RAL mark"],
      },
    ],
  },
  {
    id: "bendaggi",
    anchor: "prod-bendaggi",
    to: "/prodotti/bendaggi",
    name: "Bandages",
    badge: "Compression therapy",
    theme: "navy",
    intro: "Bandages for compression therapy and support, in different types depending on the treatment phase.",
    items: [
      { id: "bend-adesivi", name: "Adhesive bandages", img: IMG.fabric, short: "Muscle, tendon and joint support with porous adhesive fixing." },
      { id: "bend-coesivi", name: "Cohesive bandages", img: IMG.fabric, short: "Non-slip, for the decongestion phase of compression therapy." },
      { id: "bend-nonadesivi", name: "Non-adhesive bandages", img: IMG.fabric, short: "Short, medium and strong elasticity for compression and orthopaedics." },
    ],
  },
  {
    id: "pressoterapia",
    anchor: "prod-pressoterapia",
    to: "/prodotti/pressoterapia",
    name: "Pressotherapy",
    badge: "Medical Pressotherapy",
    theme: "navy",
    intro: "Pressotherapy systems for sequential lymphatic drainage of the limbs.",
    items: [
      { id: "presso-advance", name: "ADVANCE electronic pressotherapy", img: IMG.pressotherapy, badge: "Flagship model", short: "Electronic pressotherapy with 4 outlets and sequential A/B programmes." },
    ],
  },
];

const SYMPTOM_STEP = {
  question: "How pronounced are your symptoms?",
  options: [
    { id: "lievi", label: "Mild — heavy legs or swelling at the end of the day", compressionClass: { level: "Class 1", desc: "Light compression: support and prevention for everyday use." } },
    { id: "moderati", label: "Moderate — visible veins or frequent swelling", compressionClass: { level: "Class 2", desc: "Medium compression: the most used in therapeutic treatment." } },
    { id: "importanti", label: "Significant — skin changes or lymphoedema", compressionClass: { level: "Class 3", desc: "Strong compression: for the most demanding clinical cases." } },
  ],
};

export const PRODUCT_QUIZ = {
  question: "What is your main need?",
  options: [
    {
      id: "prevenire",
      label: "Prevent heavy, swollen legs",
      result: { brand: "LUMAVEN", name: "Preventive Stockings", desc: "Light, discreet support for everyday use, ideal for those who stand or sit for many hours.", to: "/prodotti/lumaven" },
      next: SYMPTOM_STEP,
    },
    {
      id: "curare",
      label: "Treat a venous or lymphatic problem",
      next: {
        question: "What type of stocking do you prefer?",
        options: [
          { id: "cotone", label: "Comfortable, cotton (sensitive skin)", result: { brand: "SCHIEBLER", name: "STAR COTTON", desc: "Cotton therapeutic stocking: maximum comfort for prolonged use and sensitive skin.", to: "/prodotti/schiebler" }, next: SYMPTOM_STEP },
          { id: "quotidiana", label: "A reference for daily use", result: { brand: "SCHIEBLER", name: "GOLDPUNKT KARAT", desc: "The SCHIEBLER reference line: precision, durability and anatomical fit.", to: "/prodotti/schiebler" }, next: SYMPTOM_STEP },
          { id: "impegnativo", label: "For demanding cases or lymphoedema", result: { brand: "SCHIEBLER", name: "DOKTUS", desc: "Precise graduated compression for the most complex clinical cases and lymphoedema.", to: "/prodotti/schiebler" }, next: SYMPTOM_STEP },
        ],
      },
    },
    {
      id: "trombosi",
      label: "Prevent thrombosis (hospital stay or surgery)",
      result: { brand: "LUMAVEN", name: "Anti-thrombosis Stockings", desc: "Anti-thromboembolic prophylaxis for bedridden patients and the post-operative pathway.", to: "/prodotti/lumaven" },
    },
    {
      id: "bendaggio",
      label: "I need a bandage or pressotherapy",
      next: {
        question: "Which treatment do you need?",
        options: [
          { id: "benda", label: "Elastic bandage", result: { brand: "Bandages", name: "Bandages", desc: "Short and long stretch bandages for the intensive phase of decongestive treatment.", to: "/prodotti/bendaggi" } },
          { id: "presso", label: "Pressotherapy / drainage", result: { brand: "Pressotherapy", name: "ADVANCE Pressotherapy", desc: "Sequential lymphatic drainage with digital pressure control, 4 outlets and touch screen.", to: "/prodotti/pressoterapia" } },
        ],
      },
    },
  ],
};

export const CONTACT_REASONS = [
  "Product information",
  "Measurement",
  "Home service",
  "Professional info",
  "Other",
];

export const COPY = {
  nav: { ctaBooking: "Book a Measurement", language: "Language" },
  langNames: { it: "Italiano", en: "English" },
  ui: {
    allProducts: "← All products",
    immediateAvailability: "In stock now",
    discover: "Discover",
    discoverProducts: "Discover the products",
    discoverBrand: "Discover",
    mostChosen: "Most chosen",
    brandsEyebrow: "Our brands",
    payoff: "Reliability you can wear.",
    seeAllProducts: "See all our products",
    ctaEyebrow: "Book now",
    ctaTitle: "The right fit starts with a conversation.",
    ctaText: "Book your professional measurement, in-store or at home. We support you every step of the way.",
    ctaBook: "Book a Measurement",
    ctaMethod: "Discover the Method",
    solutionsCount: "Five",
    solutionsLabel: "solutions",
    complementDivider: "To complete the therapy",
    testimonialsEyebrow: "Reviews",
    testimonialsTitle: "The trust of our patients.",
    testimonialsIntro: "Stories from those who chose a professional measurement and felt the difference.",
    productDiscover: "Discover the product",
    goToPage: "Go to",
    filtersLabel: "Filter by solution",
    photoSoon: "Photo coming soon",
    brandLabel: "Brand",
    noProducts: "No products in this category at the moment.",
    requestTitle: "No prices online, just the right choice.",
    requestText: "Contact us for dedicated advice and a professional measurement.",
    requestCta: "Request information",
    finderEyebrow: "Find the right product",
    finderRestart: "Start over",
    finderQuestion: "Question",
    finderHint: "Choose the answer closest to your situation.",
    finderWeRecommend: "We recommend",
    finderSeeProduct: "See the product",
    finderClassTitle: "Recommended compression class",
    finderClassNote: "Indicative only: the final class is confirmed by the specialist during the measurement.",
  },
};
